import React, { useEffect, useState } from "react";
import { IComponentParent } from "sonobello.utilities.react";

import LoadingExpander from "../../../App/Components/LoadingExpander";
import ISchedulingLoaderProps from "../Types/ISchedulingLoaderProps";

/** Shows a loading spinner until the booking controller constraints are met. */
const SchedulingLoader: React.FC<ISchedulingLoaderProps & IComponentParent> = ({
  bookingController,
  patientFirstName,
  reservation,
  router,
  children
}) => {
  const [isLoading, setIsLoading] = useState(!bookingController?.selected);

  useEffect(() => {
    setIsLoading(l => (!l ? l : !bookingController?.selected));
  }, [bookingController]);

  useEffect(() => {
    if (!reservation && bookingController && !bookingController.isBookingPossible) {
      router.goToNoAvailabilityView({ patientFirstName });
    }
  }, [bookingController, patientFirstName]);

  return isLoading ? <LoadingExpander message="Loading the Calendar..." /> : <>{children}</>;
};

export default SchedulingLoader;
